import { usePitchDeckTopicDetailLazyQuery } from 'generated/graphql';



export function usePitchDeckTopicDetail() {
  const [fnRunQuery, tuple] = usePitchDeckTopicDetailLazyQuery({ fetchPolicy: 'cache-first' });

  async function fnWrappedQuery(title: string) {
    await fnRunQuery({ variables: { title } });
  }

  const detail = tuple.data?.pitchDeckTopicDetail;



  return {
    fnRunQuery: fnWrappedQuery,
    loading: tuple.loading,
    data: {
      id: detail?.id,
      title: detail?.title,
      description: detail?.description,
      whyIsThisImportant: detail?.whyIsThisImportant,
      whatYouWillNeed: detail?.whatYouWillNeed.replace(/\u2022/g, '').split('\u000A'),
      potentialPitfalls: detail?.potentialPitfalls.replace(/\u2022/g, '').split('\u000A'),
      commonSuccesses: detail?.commonSuccesses.replace(/\u2022/g, '').split('\u000A'),
      closingThoughts: detail?.closingThoughts
    }
  };
}
